import React from 'react';

function CombinationTutorial() {
  return (
    <div className="tutorial-section" style={{
      background: '#f8f9fa',
      border: '1px solid #dee2e6',
      borderRadius: '8px',
      padding: '20px',
      margin: '20px 0'
    }}>
      <h3 style={{ color: '#495057', marginBottom: '15px' }}>🔄 选择刷分组合并填入钱包地址</h3>
      
      <div className="tutorial-steps">

        <div className="tutorial-step" style={{ marginBottom: '20px' }}>
          <h4 style={{ color: '#007bff', marginBottom: '10px' }}>步骤1: 选择一个刷分组合</h4>
          <p style={{ color: '#6c757d', fontSize: '16px' }}>
            在网页上选择一个合适的刷分组合。
          </p>
          <div style={{ textAlign: 'center', marginBottom: '10px' }}>
            <img 
              src="/images/select-combination.png"
              alt="选择刷分组合"
              style={{ 
                maxWidth: '100%', 
                height: 'auto',
                border: '1px solid #ddd',
                borderRadius: '5px'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div style={{ 
              display: 'none', 
              padding: '40px', 
              backgroundColor: '#f8f9fa', 
              border: '2px dashed #dee2e6',
              borderRadius: '5px',
              color: '#6c757d',
              textAlign: 'center'
            }}>
              📱 选择刷分组合界面图片
            </div>
          </div>
        </div>

        <div className="tutorial-step" style={{ marginBottom: '20px' }}>
          <h4 style={{ color: '#007bff', marginBottom: '10px' }}>步骤2: 填入钱包地址</h4>
          <p style={{ color: '#6c757d', fontSize: '16px' }}>
            按照下面的教程把你的地址粘进去。
          </p>
          <div style={{ textAlign: 'center', marginBottom: '10px' }}>
            <img 
              src="/images/enter-wallet-address.png"
              alt="填入钱包地址"
              style={{ 
                maxWidth: '100%', 
                height: 'auto',
                border: '1px solid #ddd',
                borderRadius: '5px'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div style={{ 
              display: 'none', 
              padding: '40px', 
              backgroundColor: '#f8f9fa', 
              border: '2px dashed #dee2e6',
              borderRadius: '5px',
              color: '#6c757d',
              textAlign: 'center'
            }}>
              📱 填入钱包地址界面图片
            </div>
          </div>
        </div>
        
        <div className="tutorial-note" style={{
          backgroundColor: '#e2f3ff',
          padding: '15px',
          borderRadius: '5px',
          marginTop: '20px'
        }}>
          <h4 style={{ color: '#0069d9', marginBottom: '10px' }}>提示:</h4>
          <p style={{ color: '#495057', fontSize: '14px' }}>
            确保选择正确的刷分组合，并准确填入您的BSC钱包地址，以确保资金能正确发送到您的钱包。
          </p>
        </div>
      </div>
    </div>
  );
}

export default CombinationTutorial; 